/**
 * Opens the Need Assistance form in a new tab
 */
export const openNeedAssistanceForm = () => {
  window.open(
    'https://docs.google.com/forms/d/e/1FAIpQLSes9_s1g84sDU4e8-3Y8MY6pN-Od51y5pt99YN6XrvoSCjVLg/viewform?usp=dialog',
    '_blank',
    'noopener,noreferrer'
  );
};
